import { Dispatch }         from "redux";
import Account              from "../../../domain/account/Account";
import AccountRepository    from "../../../domain/account/AccountRepository";
import { setAccountAction } from "../../redux/account/AccountAction";

export default class AccountDataSource implements AccountRepository {
  readonly dispatch: Dispatch;

  constructor(dispatch: Dispatch) {
    this.dispatch = dispatch;
  }

  store(account: Account): void {
    this.dispatch(setAccountAction(account));
  }
}